module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-circles"
  }, [(_vm.props) ? _c('div', {
    staticClass: "block-circles__bg"
  }, [_c('div', {
    staticClass: "block-circles__container"
  }, _vm._l((_vm.props), function(circle, j, i) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (i <= _vm.counter),
        expression: "i <= counter"
      }],
      staticClass: "block-circles__circle",
      on: {
        "click": function($event) {
          _vm.displayEvents(i)
        }
      }
    }, [_c('div', {
      staticClass: "block-circles__circle--overlay",
      class: {
        "block-circles__circle--overlay-active": _vm.showEvent === i
      },
      staticStyle: {
        "background-image": "url(https://coosmiles.com/static/CircleOverlay.svg)"
      }
    }), (circle.acf.events) ? _c('div', {
      staticClass: "block-circles__circle--image",
      style: ("background-image: url(" + circle.acf.events.image + ");")
    }, [_c('div', {
      staticClass: "block-circles__circle--info",
      class: {
        "block-circles__circle--info-active": _vm.showEvent === i
      }
    }, [_c('div', {
      staticClass: "block-circles__circle--title",
      domProps: {
        "innerHTML": _vm._s(circle.title.rendered)
      }
    }), _c('div', {
      staticClass: "block-circles__circle--content",
      domProps: {
        "innerHTML": _vm._s(circle.acf.events.snippet)
      }
    })])]) : _vm._e()])
  }))]) : _vm._e(), _c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointLoad,
        options: _vm.intersectionLoadOptions
      }),
      expression: "{ active: true, callback: onWaypointLoad, options: intersectionLoadOptions }"
    }],
    staticClass: "block-circles__button-container",
    class: {
      "block-circles__button-container--active": _vm.fadeLoad
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (Object.keys(_vm.props).length > _vm.counter + 1),
      expression: "Object.keys(props).length > counter + 1"
    }],
    staticClass: "block-circles__load",
    on: {
      "click": _vm.load
    }
  }, [_vm._v("Load More            ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7590bd16","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-circles/block-circles.pug
// module id = 588
// module chunks = 1